/* JuvoPaws — shared PDP section behaviour.
   Every section CTA carries [data-jp-scroll]; clicking one scrolls back up to the
   buy box at the top of the page instead of navigating anywhere. */
(function () {
  if (window.__jpBase) return;
  window.__jpBase = true;

  // The buy box is the JuvoPaws Hero section. Fall back to anything explicitly
  // marked, then to the first product form, then to the top of the page.
  function buyBox() {
    return (
      document.querySelector('[data-jp-buybox]') ||
      document.querySelector('[id^="jp-hero-"]') ||
      document.querySelector('.jp-hero') ||
      document.querySelector('form[action*="/cart/add"]')
    );
  }

  // Horizon renders the page inside a scrolling wrapper rather than the window,
  // so walk up for whichever ancestor actually scrolls.
  function scroller(el) {
    for (var n = el && el.parentElement; n && n !== document.body; n = n.parentElement) {
      var oy = getComputedStyle(n).overflowY;
      if ((oy === 'auto' || oy === 'scroll') && n.scrollHeight > n.clientHeight + 20) return n;
    }
    return null;
  }

  function goToBuyBox() {
    var target = buyBox();
    if (!target) return;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var behavior = reduce ? 'auto' : 'smooth';
    var sc = scroller(target);
    if (sc) {
      var top = target.getBoundingClientRect().top - sc.getBoundingClientRect().top + sc.scrollTop;
      sc.scrollTo({ top: Math.max(0, top - 12), behavior: behavior });
    } else {
      var y = target.getBoundingClientRect().top + (window.pageYOffset || document.documentElement.scrollTop);
      window.scrollTo({ top: Math.max(0, y - 12), behavior: behavior });
    }
  }

  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-jp-scroll]');
    if (!a) return;
    e.preventDefault();
    goToBuyBox();
  });
})();
